import { inject } from '@angular/core';
import { Actions, createEffect, FunctionalEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import {
  coordinateSystemsFailure,
  loadCoordinateSystems,
  loadCoordinateSystemsSuccess,
} from './coordinate-systems.actions';
import { CoordinateSystemsApiService } from '@app/api/services/coordinate-systems-api.service';

export const loadCoordinateSystems$: FunctionalEffect = createEffect(
  (actions$ = inject(Actions), coordinateSystemsApiService = inject(CoordinateSystemsApiService)) =>
    actions$.pipe(
      ofType(loadCoordinateSystems),
      switchMap(() =>
        coordinateSystemsApiService.getAll().pipe(
          map(response => loadCoordinateSystemsSuccess({ coordinateSystems: response.data })),
          catchError(error => of(coordinateSystemsFailure({ error })))
        )
      )
    ),
  { functional: true }
);
